<template>
  <AppDialog
    class="report-saved-report-filter-dialog"
    title="Save filters"
    append-to-body
    :show="show"
    @close="close"
  >
    <div class="row">
      <div class="col-sm-12">
        <div
          class="form-group"
          :class="{ 'has-error': invalid }"
        >
          <label
            for="savedReportFilter_name"
            class="control-label"
          >
            Name
          </label>
          <AppInput
            id="savedReportFilter_name"
            ref="nameInput"
            v-model="currentSavedReportFilter.name"
            required
            @enter="save"
          ></AppInput>
          <span
            v-if="invalid"
            class="help-block"
          >
            can't be blank
          </span>
        </div>
        <div class="form-group">
          <label
            for="savedReportFilter_description"
            class="control-label"
          >
            Description
          </label>
          <textarea
            id="savedReportFilter_description"
            v-model="currentSavedReportFilter.description"
            class="form-control text"
          ></textarea>
        </div>
      </div>
    </div>
    <template #footer>
      <button
        class="btn btn-default"
        @click="close"
      >
        Cancel
      </button>
      <button
        class="btn btn-primary"
        type="submit"
        :disabled="saving"
        @click="save"
      >
        {{ saveButtonLabel }}
      </button>
    </template>
  </AppDialog>
</template>

<script>
import { clone } from 'lodash-es';
import { mapActions } from 'vuex';

const defaultSavedReportFilter = {
  name: null,
  description: null,
};

export default {
  name: 'ReportSavedReportFilterDialog',
  props: {
    savedReportFilter: {
      type: Object,
    },
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    const currentSavedReportFilter = this.savedReportFilter || defaultSavedReportFilter;

    return {
      saving: false,
      invalid: false,
      currentSavedReportFilter: clone(currentSavedReportFilter),
    };
  },
  computed: {
    saveButtonLabel() {
      if (this.isNew) {
        return this.saving ? 'Saving...' : 'Save';
      }

      return this.saving ? 'Updating...' : 'Update';
    },
    isNew() {
      return !this.currentSavedReportFilter.id;
    },
  },
  watch: {
    show(newVal) {
      if (newVal) {
        const currentSavedReportFilter = this.savedReportFilter || defaultSavedReportFilter;

        this.currentSavedReportFilter = clone(currentSavedReportFilter);

        this.$nextTick(() => {
          this.$refs.nameInput.focus();
        });
      }
    },
  },
  methods: {
    ...mapActions(['analyticsTrackReport']),
    reset() {
      this.invalid = false;
    },
    validate() {
      if (this.currentSavedReportFilter.name && this.currentSavedReportFilter.name.trim().length > 0) {
        this.invalid = false;
      } else {
        this.invalid = true;
      }

      return !this.invalid;
    },
    save() {
      if (this.validate()) {
        let action;
        const errorMessage = `There was an error when ${this.isNew ? 'saving' : 'updating'} those filters`;
        const successMessage = `"${this.currentSavedReportFilter.name}" has been ${this.isNew ? 'saved' : 'updated'}`;

        if (this.isNew) {
          action = 'createSavedReportFilter';
        } else {
          action = 'updateSavedReportFilter';
        }

        const success = () => {
          this.$appMessage(successMessage);
          this.close();
          this.isNew &&
            this.analyticsTrackReport({
              event: 'Filters saved',
              groupProps: true,
              dateProps: true,
              colsProps: true,
              filtersProps: true,
            });
        };
        const error = () => {
          this.$appMessage(errorMessage);
        };
        const fin = () => {
          this.saving = false;
        };

        this.saving = true;
        this.$store.dispatch(action, this.currentSavedReportFilter).then(success, error).then(fin);
      }
    },
    close() {
      this.reset();
      this.$emit('close');
    },
  },
};
</script>
